export default [
    {
        value: "PosDoutorado",
        text: "Pós-doutorado(Stricto Sensu)"
    },
    {
        value: "Doutorado",
        text: "Doutorado(Stricto Sensu)"
    },
    {
        value: "Mestrado",
        text: "Mestrado(Stricto Sensu)"
    },
    {
        value: "Especializacao",
        text: "Especialização(Lacto Sensu)"
    },
]